/**
 * Site-wide animations
 */

import $ from 'jquery';

const animations = {
  defaultObserver: null,

  // Check for JS on page load
  initCheckJS: () => {
    if ($('.site-main').hasClass('no-js')) {
      $('.site-main').removeClass('no-js');
    }
  },

  // Intersection observer for most content - No delay on items
  initDefaultIntersectionObserver: () => {
    $(window).on('beforeunload', function () {
      $(window).scrollTop(0);
    });

    /* eslint-disable no-unused-vars */
    const callback = (entries, observer) => {
      entries.forEach((entry) => {
        // If observed object is off-screen, and hasn't already animated
        if (entry.intersectionRatio === 0 && !entry.target.classList.contains('fadeIn')) {
          // Hide object with css
          entry.target.classList.add('hide');
        }

        // If observed object enters screen,
        if (entry.isIntersecting) {
          // Animate with a flat delay
          setTimeout(() => {
            entry.target.classList.add('fadeIn');
          }, 250);
        }
      });
    };
    /* eslint-enable no-unused-vars */

    // Default Insection Observer options
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.3,
    };

    // Set default Intersection Observer
    animations.defaultObserver = new IntersectionObserver(callback, options);
  },

  // Init animations for hero blocks (Seperate because they should fire on load)
  initHeroAnimations: () => {
    // Get Hero blocks
    const contentArea = $('.entry-content');
    const main = $('main');
    let content;
    let hero;
    let container;

    if (!main.hasClass('is-post')) {
      hero = contentArea.find(':first');
    }

    if (hero !== undefined) {
      container = hero.find('.media');

      if (hero.hasClass('video')) {
        if (
          container.hasClass('video-container') &&
          !container.hasClass('no-video')
        ) {
          content = container.find('iframe');
        } else {
          content = container.find('img');
        }
      } else {
        content = container.find('img');
      }

      setTimeout(() => {
        content.css('opacity', '1');
        content.css('transform', 'translate(0, 0)');
      }, 1000);
    }
  },

  // Init animations for most content using default observer
  initContentAnimations: () => {
    // Get blocks
    const blocks = $('.block');

    // For each block
    blocks.each(function () {
      const $this = $(this);

      // Get animating objects
      const animateObjects = $this.find('.animate');

      // Attach each object to observer
      animateObjects.each(function () {
        animations.defaultObserver.observe(this);
      });
    });

    // Handle core/wp-paragraphs
    const paragraphs = $('.entry-content').find('> .container');

    if (paragraphs.length > 0) {
      paragraphs.each(function () {
        const $this = $(this);

        // Get animating objects
        const animateObjects = $this.find('.animate');

        // Attach each object to observer
        animateObjects.each(function () {
          animations.defaultObserver.observe(this);
        });
      });
    }

    // Handle company pages 'next-link'
    const nextLink = $('.next-sub-page');

    if (nextLink.length > 0) {
      nextLink.each(function () {
        const $this = $(this);

        if ($this.hasClass('animate')) {
          animations.defaultObserver.observe(this);
        }
      });
    }
  },
};

export default animations;
